import { View, ViewType } from "@common/types/views/views";

export enum BankReconciliationColumn {
    ENTITY = "entity",
    ACCOUNT_NAME = "accountName",
    START_DATE = "startDate",
    BEGINNING_BALANCE = "beginningBalance",
    END_DATE = "endDate",
    ENDING_BALANCE = "endingBalance",
    CONTINUOUS_RECONCILIATION = "continuousReconciliation",
    ACTIONS = "actions",
}

export interface BankReconciliationView extends View {
    type: ViewType.BANK_RECONCILIATION;
    columns: Array<{ id: BankReconciliationColumn; options?: any }>;
}
